
export const SET_POSITION = 'SET_POSITION'
export const SAVE_PAGE = 'SAVE_PAGE'





// WEBPACK FOOTER //
// ./src/story/mutation-types.js